import { Typography } from '@mui/material';

import { PanelProps } from './components/Panel/types';

import Image from '../../components/Image';

const panels: PanelProps[] = [
  {
    asset: (
      <Image
        alt='Live Blackjack Cover Image'
        thumbnailSrc='https://cdn.tain.com/demo/cover/low-quality/blackjack.png'
        fullSrc='https://cdn.tain.com/demo/cover/high-quality/blackjack.png'
      />
    ),
    renderLabel: (props) => <Typography {...props}>{`Live\nBlackjack`}</Typography>,
    renderDescription: (props) => (
      <Typography {...props}>
        {`A fabulous selection of Blackjack tables brought to you by real\ndealers and available on any device.`}
      </Typography>
    )
  },
  {
    asset: (
      <Image
        alt='Odds Feed Cover Image'
        thumbnailSrc='https://cdn.tain.com/demo/cover/low-quality/odds-feed.png'
        fullSrc='https://cdn.tain.com/demo/cover/high-quality/odds-feed.png'
      />
    ),
    renderLabel: (props) => (
      <Typography {...props} align='center'>
        Odds Feed
      </Typography>
    ),
    renderDescription: (props) => (
      <Typography {...props} align='center'>
        {`A knock-out Odds Feed solution that offers pre-match and live betting\nodds on 1000s of events every month.`}
      </Typography>
    ),
    sx: { alignItems: 'center', justifyContent: 'center' }
  },
  {
    asset: (
      <Image
        alt='Live Roulette Cover Image'
        thumbnailSrc='https://cdn.tain.com/demo/cover/low-quality/roulette.png'
        fullSrc='https://cdn.tain.com/demo/cover/high-quality/roulette.png'
      />
    ),
    renderLabel: (props) => <Typography {...props}>{`Live\nRoulette`}</Typography>,
    renderDescription: (props) => (
      <Typography {...props}>
        {`An exciting range of fan-favourite Roulette variants streamed\nin hi-res HD quality.`}
      </Typography>
    )
  },
  {
    asset: (
      <Image
        alt='Live Baccarat Cover Image'
        thumbnailSrc='https://cdn.tain.com/demo/cover/low-quality/baccarat.png'
        fullSrc='https://cdn.tain.com/demo/cover/high-quality/baccarat.png'
      />
    ),
    renderLabel: (props) => <Typography {...props}>{`Live\nBaccarat`}</Typography>,
    renderDescription: (props) => (
      <Typography {...props}>
        {`Enjoy table-side access to the most popular Baccarat variants around,\nbrought to you live from Portomaso Casino.`}
      </Typography>
    )
  },
  {
    asset: (
      <Image
        alt='Live Dragon Tiger Cover Image'
        thumbnailSrc='https://cdn.tain.com/demo/cover/low-quality/dragon-tiger.png'
        fullSrc='https://cdn.tain.com/demo/cover/high-quality/dragon-tiger.png'
      />
    ),
    renderLabel: (props) => <Typography {...props}>{`Live\nDragon Tiger`}</Typography>,
    renderDescription: (props) => (
      <Typography {...props}>
        {`Lightning-paced rounds of live Dragon Tiger\nbeautifully optimised for all devices.`}
      </Typography>
    )
  },
  {
    asset: (
      <video autoPlay controls={false} loop muted>
        <source src='https://cdn.tain.com/demo/cover/promo/promo.mp4' type='video/mp4' />
        <track kind='captions' />
      </video>
    ),
    renderLabel: (props) => <Typography {...props}>{`Live\nCasino`}</Typography>,
    renderDescription: (props) => (
      <Typography {...props}>
        {`Amazing Gaming's Live Casino solution brings the thrill of live dealer games\ndirectly to your desktop, mobile, or tablet in hi-res HD quality.`}
      </Typography>
    )
  }
];

export default panels;
